import { appRoutes, foremanRoute } from '@utils/consts';
import { foremanSharedRoutes } from '@pages/foreman/shared/routes';

export const foremanSchedulesRoutes = [
  {
    path: foremanRoute.schedules,
    children: [
      {
        path: appRoutes.base,
        lazy: async () => {
          const { ForemanSchedules } = await import('@pages/foreman/schedules');
          return {
            Component: () => <ForemanSchedules />,
          };
        },
      },
      foremanSharedRoutes,
    ],
  },
];
